/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import * as events from '../messaging/events';

export function useOnWebSocketUpdate<T>(topic: string, callbackFn: (json: any) => void, deps: any[] = []) {
    useEffect(() => {
        const handleMessage = (json: any) => {
            callbackFn(json);
        };

        events.on(topic, handleMessage);

        return () => {
            events.off(topic, handleMessage);
        };
    }, [deps]);

    useEffect(() => {
        events.subscribe(topic);

        return () => {
            events.unsubscribe(topic);
        };
    }, []);
}
